module.exports = __webpack_public_path__ + "img/product.b303f46d.png";